class CustomCommentsController {}

angular.module('app.scouting').component('customComments', {
  templateUrl: 'scouting/components/custom-comments.html',
  controller: CustomCommentsController,
});
